import Form, { InputType } from '../../lib/Formik';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import { connect } from 'react-redux';
import { OTP_ACTIONS } from '../../utils/constants';
import { getOtpForgotPassword } from '../../redux-store/actions/login';
import * as yup from 'yup';

const {
    forgotPassword,
    common,
    login: { form },
} = en;
const formFields: Partial<InputType>[] = [
    {
        label: forgotPassword.label,
        name: 'userId',
        type: 'text',
    },
];

type forgotPasswordState = {
    userId: string;
};

const validationSchema = yup.object({
    userId: yup
        .string()
        .required(form.panOrPekrn.validation.emptyError)
        .length(10, form.panOrPekrn.validation.minLengthError),
});

const initialValues = {
    userId: '',
};
function ForgotPassword(props: any) {
    const onSubmit = async (
        values: forgotPasswordState,
        action: FormikHelpers<forgotPasswordState>,
    ) => {
        try {
            const { userId } = values;
            let res = await props.getOtpForgotPassword({
                userId: userId.toUpperCase(),
                action: OTP_ACTIONS.forgot_password,
            });
            props.history.push('forgot-password-otp', {
                userId: userId.toUpperCase(),
                ...(res || {}).body,
            });
            action.setSubmitting(false);
        } catch (e: any) {
            alert(e.message);
        }
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema,
    });
    return (
        <div className="signup-padding">
            <h4 className="text-center">{forgotPassword.heading}</h4>
            <p className="text-center subheading">{forgotPassword.info}</p>
            <Form
                ui={formFields}
                submitButtonLabel={forgotPassword.action.otpRequest.label}
                formik={formik}
            >
                {/* <div className="back">
                    <a href="#">Back to Sign Up</a>
                </div> */}
            </Form>
        </div>
    );
}

export default connect(null, { getOtpForgotPassword })(ForgotPassword);
